import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import age18Png from '@/assets/landing-age-selection/lymphatic-walking-main/age-18.png'
import age40Png from '@/assets/landing-age-selection/lymphatic-walking-main/age-40.png'
import age50Png from '@/assets/landing-age-selection/lymphatic-walking-main/age-50.png'
import age60Png from '@/assets/landing-age-selection/lymphatic-walking-main/age-60.png'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		// TODO(L10N-2654): hardcoded EN — the funnel is EN-only for now, web.json has no lymphatic keys.
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Lymphatic<br/>Walking Plan',
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		// Four clickable cards, no otherAgesButton — Figma promotes 18-39 out of the escape link and
		// collapses 60-69 + 70+ into a single "60+" card, same pattern as the female lymphatic landing.
		// TODO(GT-4713): 'Age: 18-39' and '60+' are hardcoded — web.json has age_range keys only for
		// 40_49 / 50_59 / 60_69 / 70_80. The 40-49 and 50-59 labels below come from existing keys whose
		// values match the design verbatim.
		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'blue',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-39',
					label: 'Age: 18-39',
					img: age18Png,
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: age40Png,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: age50Png,
				},
				{
					// Label follows Figma ("60+"); analyticValue reuses the 60-80 bucket introduced by
					// DEV-34798 so no new analytics value is created.
					value: 60,
					analyticValue: '60-80',
					label: '60+',
					img: age60Png,
				},
			],
		}),
	},
}

export default schema
